import React from 'react';

export const TermsOfService = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-orange-600 via-orange-500 to-red-600 text-white py-20 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxsZWdhbCUyMGJ1c2luZXNzfGVufDB8fHx8MTc2NDM2MzY4MXww&ixlib=rb-4.1.0&q=85"
            alt="Legal business background"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-orange-600/75 via-orange-500/75 to-red-600/80"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">Terms of Service</h1>
            <p className="text-xl text-orange-100">Last Updated: January 2025</p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto prose prose-lg">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Agreement to Terms</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              By accessing or using Corporate Marking's website and services, you agree to be bound by these Terms of Service. If you disagree with any part of these terms, you may not access our services.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">Services Description</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Corporate Marking provides trademark registration, copyright registration, trademark search, company formation, and related intellectual property services. We facilitate the preparation and filing of applications with relevant government agencies but do not guarantee approval of any application.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">User Responsibilities</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              When using our services, you agree to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6">
              <li>Provide accurate, complete, and current information</li>
              <li>Maintain the confidentiality of your account credentials</li>
              <li>Notify us immediately of any unauthorized use of your account</li>
              <li>Comply with all applicable laws and regulations</li>
              <li>Not use our services for any unlawful or fraudulent purpose</li>
            </ul>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">Fees and Payment</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              You agree to pay all fees associated with the services you select. Fees are non-refundable except as required by law or as explicitly stated in our refund policy. Government filing fees are separate from our service fees and are non-refundable.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">Intellectual Property</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              The content, features, and functionality of our website are owned by Corporate Marking and are protected by copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, modify, or create derivative works without our express written permission.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">No Guarantee of Results</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              While we strive to provide excellent service, we cannot guarantee that any trademark or copyright application will be approved by the USPTO or Copyright Office. Approval is at the sole discretion of the relevant government agency.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">Limitation of Liability</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              To the maximum extent permitted by law, Corporate Marking shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use our services.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">Attorney-Client Relationship</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Use of our website does not create an attorney-client relationship. An attorney-client relationship is only formed when you engage our services and we accept your case in writing.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">Governing Law</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              These Terms of Service shall be governed by and construed in accordance with the laws of the State of California, without regard to its conflict of law provisions.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">Dispute Resolution</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Any disputes arising from these terms or your use of our services shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">Changes to Terms</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              We reserve the right to modify these Terms of Service at any time. We will notify users of material changes by posting the new terms on our website. Your continued use of our services after such changes constitutes acceptance of the new terms.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">Contact Information</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              For questions about these Terms of Service, please contact us:
            </p>
            <ul className="list-none text-gray-700 space-y-2 mb-6">
              <li>Email: legal@corporatemarking.com</li>
              <li>Phone: +1 (855) 350 1458</li>
              <li>Address: 515 Flower St, Los Angeles, CA 90071</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};